<template>
  <!-- 部门管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head topAn">
        <div class="head_left">
          <h3 v-if="breadcrumbArr.length > 0">
            {{ breadcrumbArr[breadcrumbArr.length - 1].deptName }}的子部门
          </h3>
          <el-button
            type="primary"
            size="mini"
            plain
            @click="clickAddSection('all')"
            v-if="breadcrumbArr.length == 0"
          >
            <i class="el-icon-plus"></i>
            <span>添加部门</span>
          </el-button>
          <el-button
            type="primary"
            size="mini"
            plain
            @click="clickAddSection('child')"
            v-else
          >
            <i class="el-icon-plus"></i>
            <span
              >添加[{{
                breadcrumbArr[breadcrumbArr.length - 1].deptName
              }}]子部门</span
            >
          </el-button>
        </div>
        <!-- 筛选 -->
        <div class="screening_box" v-if="!is_lookChild">
          <el-input
            v-model="searchFrom.deptName"
            placeholder="请输入部门名称"
            clearable
            @change="search"
          ></el-input>
          <el-select
            v-model="searchFrom.companyId"
            filterable
            :disabled="!isAdmin"
            placeholder="请选择公司"
            @change="selectCompany"
          >
            <el-option
              :label="company.companyname"
              :value="company.companyid"
              v-for="company in search_companyList"
              :key="company.companyid"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- 部门列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
          stripe
        >
          <el-table-column
            prop="deptId"
            :show-overflow-tooltip="true"
            label="部门ID"
          >
          </el-table-column>
          <el-table-column prop="deptName" label="部门名称"> </el-table-column>
          <el-table-column prop="deptParentId" label="父级部门ID">
          </el-table-column>
          <el-table-column label="公司">
            <template slot-scope="scope">
              {{ companyObj[scope.row.companyId] }}
            </template>
          </el-table-column>
          <el-table-column label="子部门">
            <template slot-scope="scope">
              <el-button
                size="mini"
                style="margin-left: 0px;"
                v-if="scope.row.children && scope.row.children.length != 0"
                @click.stop="lookChild(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                style="margin-left: 0px;"
                v-else
                @click.stop="addChild(scope.row, scope.$index)"
                >添加子部门</el-button
              >
            </template>
          </el-table-column>
          <el-table-column align="right" label="操作" width="240">
            <template slot-scope="scope">
              <template>
                <div>
                  <el-button
                    size="mini"
                    @click.stop="personnelManage(scope.row)"
                    >人员管理</el-button
                  >
                  <el-button
                    size="mini"
                    style="margin-left: 5px;"
                    @click.stop="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    :hideIcon="true"
                    title="确定删除吗？"
                    @confirm="delSection(scope.$index, scope.row)"
                  >
                    <el-button
                      slot="reference"
                      size="mini"
                      type="danger"
                      style="margin-left: 5px;"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </div>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
        v-if="!is_lookChild"
      />

      <div class="paging_box breadcrumb_box" v-else>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <span class="text" @click="goBack(-1)">首页</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, i) in breadcrumbArr" :key="i">
            <span
              class="text"
              :class="{ active: i == breadcrumbArr.length - 1 }"
              @click="goBack(i)"
              >{{ item.deptName }}</span
            >
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 添加/编辑部门 -->
      <el-dialog
        :title="is_add ? '添加部门' : '编辑部门'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- 父级部门id -->
          <el-form-item label="父级部门id" prop="deptParentId">
            <el-input
              v-model="ruleForm.deptParentId"
              :disabled="is_child"
              clearable
              placeholder="请输入父级部门id"
            ></el-input>
          </el-form-item>
          <!-- 公司 -->
          <el-form-item label="公司" prop="companyId">
            <el-select
              v-model="ruleForm.companyId"
              filterable
              :disabled="is_child || !isAdmin"
              placeholder="请选择公司"
            >
              <el-option
                :label="company.companyname"
                :value="company.companyid"
                v-for="company in company_list"
                :key="company.companyid"
                >{{ company.companyname }}</el-option
              >
            </el-select>
          </el-form-item>
          <!-- 部门id -->
          <el-form-item label="部门id" prop="deptId">
            <el-input
              v-model="ruleForm.deptId"
              placeholder="请输入部门id"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 部门名称 -->
          <el-form-item label="部门名称" prop="deptName">
            <el-input
              v-model="ruleForm.deptName"
              placeholder="请输入部门名称"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>

      <!-- 人员管理 -->
      <el-dialog
        :title="section_name + ' 人员管理'"
        top="10vh"
        width="70%"
        :visible.sync="personnel_show"
      >
        <el-dialog
          width="40%"
          :title="!is_add ? '编辑用户' : '添加用户'"
          :close-on-click-modal="false"
          @close="cancelChangeWx"
          :visible.sync="innerVisible"
          append-to-body
        >
          <el-form :model="personnelForm" :rules="rules" ref="personnelForm">
            <!-- 用户 -->
            <el-form-item label="用户" prop="unionid">
              <el-select
                v-model="personnelForm.unionid"
                filterable
                placeholder="请选择用户"
              >
                <el-option
                  :label="user.createName"
                  :value="user.unionid"
                  v-for="(user, index) in user_list"
                  :key="index"
                  >{{ user.createName }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button :disabled="btnLoading" @click="cancelChangeWx"
              >取 消</el-button
            >
            <el-button
              type="primary"
              :loading="btnLoading"
              :disabled="btnLoading"
              @click="savePersonnel"
              >{{ !is_add ? "保 存" : "确 定" }}</el-button
            >
          </div>
        </el-dialog>
        <!-- 添加/编辑用户 -->
        <div class="add_wxUser">
          <el-button
            type="primary"
            size="mini"
            plain
            class="add_btn"
            @click="addPersonnel"
          >
            添加用户
          </el-button>
          <div class="select_box">
            <el-select v-model="userId" filterable placeholder="请选择用户">
              <el-option
                :label="user.createName"
                :value="user.unionid"
                v-for="(user, index) in search_userList"
                :key="index"
                >{{ user.createName }}</el-option
              >
            </el-select>
          </div>
        </div>
        <!-- 列表 -->
        <div class="invitation_list">
          <el-table
            v-load="personnel_load"
            :data="personnelList"
            style="width: 100%"
            :height="400"
            stripe
          >
            <el-table-column
              prop="deptId"
              :show-overflow-tooltip="true"
              label="部门ID"
            >
            </el-table-column>
            <el-table-column prop="deptName" label="部门名称">
            </el-table-column>
            <el-table-column prop="createName" label="用户名称">
            </el-table-column>
            <el-table-column prop="nickName" label="昵称"> </el-table-column>
            <el-table-column align="right" label="操作" width="240">
              <template slot-scope="scope">
                <template>
                  <div>
                    <el-button
                      size="mini"
                      style="margin-left: 5px;"
                      @click="editPersonnel(scope.$index, scope.row)"
                      >编辑</el-button
                    >
                    <el-popconfirm
                      confirmButtonText="确定"
                      cancelButtonText="取消"
                      :hideIcon="true"
                      title="确定删除吗？"
                      @confirm="delPersonnel(scope.$index, scope.row)"
                    >
                      <el-button
                        slot="reference"
                        size="mini"
                        type="danger"
                        style="margin-left: 5px;"
                        >删除</el-button
                      >
                    </el-popconfirm>
                  </div>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页器 -->
        <div class="dialog_paging">
          <div class="paging_box">
            <span class="total">共{{ personnelTotal }}条</span>
            <span class="perPage_num">本页{{ personnelList.length }}条</span>
            <el-pagination
              layout="prev, pager, next"
              :current-page="personnePage"
              :page-size="personneSize"
              :total="personnelTotal"
              @current-change="changePersonnePage"
            >
            </el-pagination>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      btnLoading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      searchFrom: {
        companyId: "",
        deptName: ""
      },
      company_list: [], // 公司列表
      search_companyList: [], // 公司列表(筛选用)
      companyObj: {},
      user_list: [],
      useridObj: {},
      search_userList: [],
      dialogFormVisible: false,
      personnel_show: false,
      is_add: true,
      is_child: false,
      // 表单
      ruleForm: {
        deptId: "",
        deptParentId: "",
        deptName: "",
        companyId: ""
      },
      // 表单检验规则
      rules: {
        deptId: [{ required: true, message: "请输入部门id", trigger: "blur" }],
        deptParentId: [
          { required: true, message: "请输入父级部门id", trigger: "blur" }
        ],
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" }
        ],
        companyId: [{ required: true, message: "请选择公司", trigger: "blur" }],
        unionid: [{ required: true, message: "请选择用户", trigger: "blur" }]
      },
      table_height: 400,
      dialog_top: "10vh",
      row_index: 0,
      section_id: "",
      id: "",
      user_code: "",
      section_name: "",
      companyname: "",

      personnelForm: {
        unionid: ""
      },
      personneId: "",
      personnel_load: false,
      personnePage: 1,
      personneSize: 10,
      personnelList: [],
      personnelTotal: 0,
      userId: "",

      is_init: false,
      innerVisible: false,
      is_lookChild: false,
      breadcrumbArr: [],
      add_index: 0,
      add_type: ""
    };
  },
  computed: {
    authority() {
      return this.$route.meta.authority;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    companyId() {
      return this.$store.state.companyId;
    }
  },
  watch: {
    "searchFrom.companyId": {
      deep: true,
      handler(id) {
        this.getAllUser(id);
      }
    },
    userId(id) {
      this.personnePage = 1;
      this.getPersonnelList("search");
    }
  },
  activated() {
    this.getCompanyList();
  },
  mounted() {
    this.$nextTick(() => {
      this.changeTableHeight("init");
    });

    window.onresize = () => {
      this.changeTableHeight("onresize");
    };
  },
  methods: {
    initList() {
      this.is_init = true;
      this.searchFrom.deptName = "";
      this.page = 1;
      this.getUserList();
    },
    // 获取部门列表
    getUserList(type = "") {
      if (!this.authority) return;
      this.loading = true;
      this.$refs.table.bodyWrapper.scrollTop = 0;
      if (!this.isAdmin) this.searchFrom.companyId = this.companyId;
      this.$http({
        url: this.$api.section_list,
        data: {
          companyId: this.searchFrom.companyId,
          deptName: this.searchFrom.deptName,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        this.is_init = false;
        if (res.code == 0) {
          if (type == "search") {
            if (res.data.total == 0) this.$message("没有搜索结果");
          }
          this.total = res.data.total;
          this.tableData = res.data.concent;
        } else {
          this.total = 0;
          this.tableData = [];
        }
      });
    },
    // 获取公司列表
    getCompanyList() {
      if (!this.authority) return;
      this.$http({
        url: this.$api.company_list
      }).then(res => {
        if (res.code == 0) {
          if (!this.isAdmin) {
            res.data.forEach(val => {
              if (this.companyId == val.companyid) {
                this.company_list = [val];
                this.search_companyList = [val];
                this.searchFrom.companyId = this.companyId;
                this.page = 1;
                this.getUserList();
              }
            });
          } else {
            this.company_list = res.data;
            this.search_companyList = JSON.parse(JSON.stringify(res.data));
            this.searchFrom.companyId = res.data[0].companyid;
            this.page = 1;
            this.getUserList();
          }
          res.data.forEach(val => {
            this.companyObj[val.companyid] = val.companyname;
          });
        }
      });
    },
    // 获取所有用户
    getAllUser(companyid) {
      if (!this.authority) return;
      this.$http({
        url: this.$api.all_user,
        data: { companyid }
      }).then(res => {
        if (res.code == 0) {
          this.useridObj = {};
          this.user_list = res.data;
          this.search_userList = JSON.parse(JSON.stringify(res.data));
          this.search_userList.unshift({
            createName: "全部",
            userid: ""
          });
          res.data.forEach(val => {
            this.useridObj[val.unionid] = val.userid;
          });
        }
      });
    },
    // 新增/编辑部门请求
    editSectionReq(data) {
      this.btnLoading = true;
      this.$http({
        url: this.$api.edit_section,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          if (this.is_add) {
            let arr_length = this.breadcrumbArr.length;
            if (arr_length == 0) {
              this.initList();
            } else {
              if (this.add_type == "child") {
                this.tableData.unshift(res.data);
              } else {
                if (!this.tableData[this.add_index].children)
                  this.tableData[this.add_index].children = [];
                this.tableData[this.add_index].children.unshift(res.data);
              }
            }
            this.$hint("新增成功");
          } else {
            this.tableData[this.row_index].companyId = data.companyId;
            this.tableData[this.row_index].deptId = data.deptId;
            this.tableData[this.row_index].deptName = data.deptName;
            this.tableData[this.row_index].deptParentId = data.deptParentId;
            this.$hint("保存成功");
          }
        } else {
          this.$hint(res.code + res.message, "err");
        }
      });
    },
    // 获取部门人员列表
    getPersonnelList(type = "") {
      this.personnel_load = true;
      this.$http({
        url: this.$api.personnel_list,
        data: {
          deptId: this.section_id,
          unionid: this.userId,
          pageIndex: this.personnePage,
          pageSize: this.personneSize
        }
      }).then(res => {
        this.personnel_load = false;
        if (res.code == 0) {
          if (type == "search") {
            if (res.data.total == 0) this.$message("没有搜索到用户");
          }
          this.personnelTotal = res.data.total;
          this.personnelList = res.data.concent;
        } else {
          this.personnelTotal = 0;
          this.personnelList = [];
        }
      });
    },
    // 添加/编辑人员
    editPersonnelReq() {
      this.btnLoading = true;
      let id = "";
      if (!this.is_add) id = this.personneId;
      this.$http({
        url: this.$api.edit_personnel,
        data: {
          deptId: this.section_id,
          id,
          userId: this.useridObj[this.personnelForm.unionid],
          unionid: this.personnelForm.unionid
        }
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.innerVisible = false;
          this.$refs.personnelForm.resetFields();
          let hint_text = "添加成功";
          if (!this.is_add) hint_text = "保存成功";
          this.$hint(hint_text);
          this.getPersonnelList();
        } else {
          this.$hint(res.message, "err");
        }
      });
    },

    // 删除部门请求
    delSection(index, row) {
      this.$http({
        url: this.$api.del_section,
        data: { id: row.id }
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint(res.code + res.message, "err");
        }
      });
    },
    // 删除人员
    delPersonnel(index, row) {
      this.$http({
        url: this.$api.del_personnel,
        data: {
          id: row.id
        }
      }).then(res => {
        if (res.code == 0) {
          this.personnelList.splice(index, 1);
          this.personnelTotal--;
          this.$hint("删除成功");
        } else {
          this.$hint(res.code + res.message, "err");
        }
      });
    },
    // 编辑部门请求
    editUser(data) {
      delete data.addon;
      this.btnLoading = true;
      this.$http({
        url: this.$api.edit_user,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.$set(this.tableData, this.row_index, data);
          this.$hint("保存成功");
        } else {
          this.$hint("保存失败", "err");
        }
      });
    },
    // 翻页
    changePage(e) {
      this.page = e;
      this.getUserList();
    },
    // 人员翻页
    changePersonnePage(e) {
      this.personnePage = e;
      this.getPersonnelList();
    },
    // 筛选
    // 选择公司
    selectCompany(e) {
      e == "0"
        ? (this.searchFrom.companyId = "")
        : (this.searchFrom.companyId = e);
      this.search();
    },
    // 查看部门
    personnelManage(row) {
      this.section_id = row.deptId;
      this.section_name = row.deptName;
      this.personnel_show = true;
      this.getPersonnelList();
    },
    // 点击添加部门
    clickAddSection(type) {
      this.add_type = type;
      if (type == "child") {
        this.is_child = true;
        let len = this.breadcrumbArr.length - 1;
        this.ruleForm = {
          deptId: "",
          deptParentId: this.breadcrumbArr[len].deptId,
          deptName: "",
          companyId: this.breadcrumbArr[len].companyId
        };
      } else {
        this.is_child = false;
        this.ruleForm = {
          deptId: "",
          deptParentId: "",
          deptName: "",
          companyId: ""
        };
        if (!this.isAdmin) {
          this.ruleForm.companyId = this.companyId;
        }
      }
      this.dialogFormVisible = true;
      this.is_add = true;
    },
    // 编辑部门
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.is_add = false;
      this.row_index = index;
      this.ruleForm = {
        id: row.id,
        companyId: row.companyId,
        deptId: row.deptId,
        deptName: row.deptName,
        deptParentId: row.deptParentId
      };
    },
    // 确定新增、保存
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let item = JSON.parse(JSON.stringify(this.ruleForm));
          this.editSectionReq(item);
          this.cancel();
        } else {
          return false;
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.ruleForm.resetFields();
      this.$refs["ruleForm"].clearValidate(["losetime"]);
    },
    // 点击添加用户
    addPersonnel() {
      this.innerVisible = true;
      this.is_add = true;
      this.personnelForm = {
        unionid: ""
      };
    },
    // 点击编辑用户
    editPersonnel(index, row) {
      this.innerVisible = true;
      this.is_add = false;
      this.personnelForm.unionid = row.unionid;
      this.personneId = row.id;
    },
    // 取消新增、编辑用户
    cancelChangeWx() {
      this.innerVisible = false;
      this.$refs["personnelForm"].clearValidate(["losetime"]);
    },
    // 确定新增、编辑用户
    savePersonnel() {
      this.$refs.personnelForm.validate(valid => {
        if (valid) {
          this.editPersonnelReq();
        } else {
          return false;
        }
      });
    },
    // 查看子部门
    lookChild(row) {
      this.is_lookChild = true;
      this.tableData = row.children;
      this.breadcrumbArr.push(row);
      this.switchingHint();
    },
    // 返回到部门或某个子部门
    goBack(index) {
      let arr_length = this.breadcrumbArr.length - 1;
      if (index == arr_length) return;
      if (index == -1) {
        this.is_lookChild = false;
        this.breadcrumbArr = [];
        this.getUserList();
      } else {
        this.tableData = this.breadcrumbArr[index].children;
        this.breadcrumbArr.splice(index + 1, arr_length - index);
      }
      this.switchingHint();
    },
    // 添加子部门
    addChild(row, index) {
      this.add_type = "";
      this.add_index = index;
      this.is_child = true;
      this.dialogFormVisible = true;
      this.is_add = true;
      this.ruleForm = {
        deptId: "",
        deptParentId: row.deptId,
        deptName: "",
        companyId: row.companyId
      };
      if (!this.isAdmin) {
        this.ruleForm.companyId = this.companyId;
      }
    },
    // 搜索
    search() {
      this.page = 1;
      this.getUserList("search");
    },
    // 切换部门提示
    switchingHint() {
      let text = "首页";
      if (this.breadcrumbArr.length > 0)
        text = this.breadcrumbArr[this.breadcrumbArr.length - 1].deptName;
      this.$message({
        message: "已切换到" + text,
        type: "success"
      });
    },
    // 计算表格高度
    changeTableHeight(type) {
      if (!this.authority) return;
      let height = document.getElementById("table_list").offsetHeight;
      if (type == "onresize" && this.table_height == height) return;
      this.table_height = height;
      if (this.table_height < 550) {
        this.pageSize = 10;
      } else {
        this.pageSize = 20;
      }
    }
  }
};
</script>

<style>
.input_box .el-input__inner {
  height: 35px;
}
.date_item {
  height: 35px;
  margin-left: 10px;
}
.date_item > input {
  height: 100%;
}
</style>
<style lang="less" scoped>
.add_wxUser {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  transform: translateY(-25px);
  .el-form-item {
    margin: 0;
  }
  .input_box {
    width: 200px;
    height: 35px;
  }
  .add_btn {
    height: 35px;
    color: #fff;
    letter-spacing: 2px;
    margin-left: 10px;
    padding: 0 15px;
  }
}
.head_left {
  display: flex;
  align-items: center;
  > h3 {
    margin-right: 20px;
  }
}
.breadcrumb_box {
  justify-content: flex-start;
  .text {
    cursor: pointer;
  }
  .active {
    font-weight: bold !important;
  }
}
.invitation_list {
  width: 100%;
}
.dialog_paging {
  .paging_box {
    height: 50px;
    margin-top: 0;
  }
}

.time_item {
  display: flex;
  align-items: center;
  > span {
    width: 140px;
    margin-right: 10px;
    white-space: nowrap;
  }
}
.name_box {
  > li {
    font-size: 13px;
    color: #525f7f;
    margin-bottom: 20px;
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
    .title {
      font-size: 14px;
      color: #525f7f;
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
}
.weixin_name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/section.vue